//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
import "../CAM/CAM.BoundarySetList.js";
import "../no/ObjectList.js";
let d=[[[1,"BoundaryList",0,"CAM.BoundarySetList",0]],[[[],"CreateBoundarySet",{R_:{bndSet:"CAM.BoundarySet"}},0,0],[[],"CreateBoundaryMillingSet",{R_:{bndSet:"CAM.BoundaryMillingSet"}},0,0],[[],"CreateBoundaryTurnSet",{R_:{bndSet:"CAM.BoundaryTurnSet"}},0,0],[[],"CreateBoundarySetWireEdm",{R_:{bndSet:"CAM.BoundarySetWireEDM"}},0,0],[["face","ignoreHole","ignoreIsland","ignoreChamfer","toolSide","count"],"AppendFaceBoundary",{R_:{bndSets:"CAM.BoundarySet[]"}},5,0],[["face"],"RemoveFaceBoundary",{},1,0],[[],"CreateBoundarySetPlanarMill",{R_:{bndSet:"CAM.BoundarySetPlanarMill"}},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.CAM.Boundary = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.Boundary";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;